<template>
  <div class="review">
    <div class="el-checkbox-group review-layer">
      <el-tag size="mini"
              style="float:left;margin-left:5px;"
              v-show="curMachineAlias">{{curMachineAlias}} {{tarId}}</el-tag>
      <Version :value="version"></Version>
      <template v-if="version==='1'">
        <el-checkbox :value="true"
                     disabled>原图</el-checkbox>
        <el-checkbox v-model="showDetect">检测结果</el-checkbox>
        <el-checkbox v-model="showLabel">标注</el-checkbox>
        <el-checkbox v-model="showBlind">屏蔽区</el-checkbox>
      </template>
      <el-checkbox-group v-model="visiableLayers"
                         style="display:inline-block;margin-right:30px;"
                         v-if="version==='2'">
        <el-checkbox label="BASE_LAYER"
                     disabled>原图</el-checkbox>
        <el-checkbox label="DETECT_RESULT">检测结果</el-checkbox>
        <el-checkbox label="LABEL">标注</el-checkbox>
        <el-checkbox label="SHIELD_MANUALLY">结构件屏蔽</el-checkbox>
        <el-checkbox label="SHIELD_LINE">屏蔽</el-checkbox>
      </el-checkbox-group>
      <el-checkbox v-model="showMagnifier">放大镜
        <span @click.prevent="diameter>2&&diameter--"
              style="padding:0 5px">−</span>
        <span @click.prevent>{{diameter}}</span>
        <span @click.prevent="diameter++"
              style="padding:0 5px">+</span>
      </el-checkbox>
      <el-select v-model="bitRate"
                 placeholder="请选择视频码率"
                 title="请选择视频码率"
                 size="mini"
                 class="bitrate-select">
        <el-option v-for="item in videoBitRate"
                   :key="item.bitRate"
                   :label="item.label"
                   :value="item.bitRate">
        </el-option>
      </el-select>
    </div>
    <div class="review-labeler"
         @mousewheel.prevent="onMouseWheel">
      <h1 v-if="!tarId">请在左侧选择数据包</h1>
      <Labeler v-else-if="version==='1'"
               :video-url="videoUrl"
               :yaml-url="yamlUrl"
               :label-list="filteredLabels"
               :show-draw="false"
               :show-magnifier="showMagnifier"
               :blind="shieldInfo"
               v-model="frameIdx"
               @decoded="onDecoded" />
      <template v-else-if="version==='2'">
        <WebGLSnapshot :visiable-layers="visiableLayers"
                       :base-layer="curBaseLayer"
                       :layer-data="curLayerData"
                       :tools="tools"
                       @tool-msg="handleToolEvent"
                       mode="VIEW"></WebGLSnapshot>
        <PlayControl></PlayControl>
      </template>
      <div class="review-camera">
        摄像头：
        <el-select size="small"
                   v-model="cameraIdx"
                   placeholder="Select">
          <el-option v-for="(cameraId,idx) in cameraList"
                     :key="cameraId"
                     :label="cameraId"
                     :value="idx">{{'摄像头:'+String(cameraId).padStart(2,'0')}} |
            {{'已标注:'+(cameraInfo[cameraId]&&cameraInfo[cameraId].labeledNumber)||'0'}}
            |
            {{'已审核:'+(cameraInfo[cameraId]&&cameraInfo[cameraId].reviewedNumber)||'0'}}
          </el-option>
        </el-select>&nbsp;&nbsp;
        <el-button size="mini"
                   :disabled="isLoading||cameraIdx<1"
                   @click="cameraIdx--">上一个摄像头</el-button>
        <el-button size="mini"
                   :disabled="isLoading||cameraIdx>=cameraList.length-1"
                   @click="cameraIdx++">下一个摄像头</el-button>
      </div>
    </div>
    <div class="box"
         style="display:flex;justify-content:space-between;align-items:center;">
      <div style="display: flex;align-items: center;">标注人:
        <el-radio-group v-if="labelers.length"
                        class="review-layer"
                        v-model="selectedLabelerIdx"
                        style="display: flex;">
          <div v-for="(labeler,idx) in labelers"
               :key="idx"
               style="margin-right:20px;">
            <el-radio :label='idx'>
              {{labeler.labelerName}}
            </el-radio>
            <div class="review-tag">
              <el-tag type="primary"
                      size="mini"
                      title="已通过审核"
                      v-if="labeler.reviewStatus=='Passed'">✔</el-tag>
              <el-tag type="danger"
                      size="mini"
                      title="已被驳回"
                      v-else-if="labeler.reviewStatus=='Rejected'">✘</el-tag>
              <el-tag type="success"
                      size="mini"
                      title="最佳标注"
                      v-if="labeler.bestLabeling">★</el-tag>
            </div>
          </div>
        </el-radio-group>
        <span v-else>此数据包暂无标注记录</span></div>
    </div>
    <div class="box review-info">
      <el-table :data="labelTable"
                size="mini"
                style="align-self: flex-start;">
        <el-table-column prop="bestLabeling"
                         label="最佳标注"></el-table-column>
        <el-table-column prop="detectionMachineId"
                         label="检测机 ID"></el-table-column>
        <el-table-column prop="factoryName"
                         label="工厂名称"></el-table-column>
        <el-table-column prop="labelComment"
                         label="标注备注"></el-table-column>
        <el-table-column prop="labelTime"
                         label="标注时间"></el-table-column>
        <el-table-column prop="machineAlias"
                         label="机器别名"></el-table-column>
        <el-table-column prop="reviewComment"
                         label="审核备注"></el-table-column>
        <el-table-column prop="reviewStatus"
                         label="审核状态"></el-table-column>
        <el-table-column prop="reviewTime"
                         label="审核时间"></el-table-column>
        <el-table-column prop="reviewerName"
                         label="审核人"></el-table-column>
      </el-table>
      <div style="display:flex;margin:20px 0;">
        <ul class="review-list"
            style="flex:1;min-width: 300px;height: auto;overflow:auto;align-self: stretch;margin:0;max-width: 400px;">
          <li v-for="(label,idx) in labels"
              :key="idx"
              :class="{active:idx===selectedLabel}"
              @click="selectedLabel=idx">
            <span style="display:flex;">
              {{labelTypes[label.type].title}}
              [{{label.frameRange.join(',')}}]
            </span>
            <span>
              <el-button size="mini"
                         @click="frameIdx=label.frameRange[0]">定位</el-button>
            </span>
          </li>
        </ul>
        <ClothAssessment v-model="labelInfo.clothAssessment"
                         :config="clothAssessmentConfig"
                         :worning-keys="diffClothAssessment"
                         readonly></ClothAssessment>
      </div>
    </div>
    <div class="box">
      <div style="margin-bottom:10px;">
        <el-input type="textarea"
                  rows="1"
                  placeholder="审核备注"
                  v-model="reviewComment"> </el-input>
      </div>
      <el-button type="success"
                 @click="approveBest"
                 v-if="privileges.LabelingAdvanced">★最佳且通过</el-button>
      <el-button type="primary"
                 @click="approveNotBest"
                 v-if="privileges.LabelingAdvanced">✔通过且非最佳</el-button>
      <el-button type="danger"
                 @click="reject"
                 v-if="privileges.LabelingAdvanced">✘驳回该标注</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import c from '@/config'
import Version from '@/components/Version'
import Labeler from '@/components/Labeler'
import PlayControl from '@/components/PlayControl'
import ClothAssessment from '@/components/ClothAssessment'
import WebGLSnapshot from '@/components/WebGLSnapshot'

export default {
  data() {
    return {
      debug: c.debug,
      version: c.version,
      frameRangeLoc: this.frameRange || [],
      labelTypes: Object.freeze(c.labelTypes),
      videoBitRate: Object.freeze(c.videoBitRate),
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (this.privileges.LabelingBasic) {
      this.tarId = to.query.tarid || ''
    }
    next()
  },
  mounted() {
    if (this.privileges.LabelingBasic) {
      const queryTarId = this.$route.query.tarid || ''
      if (queryTarId && this.tarId === queryTarId) {
        this.fetchCameraList(this.tarId)
      } else {
        this.tarId = queryTarId
      }
    }
  },
  computed: {
    ...mapFields([
      'showMagnifier',
      'visiableLayers',

      'bitRate',
      'tarId',
      'frameIdx',
      'frameRange',
      'cameraIdx',
      'showDetect',
      'showLabel',
      'showBlind',

      'modified',

      'isPlaying',
      'diameter',

      'review.labelers',
      'review.selectedLabel',
      'review.selectedLabelerIdx',
      'review.reviewComment',
      'review.bestLabeling',
    ]),
    ...mapState([
      'privileges',
      'cameraList',
      'videoUrl',
      'yamlUrl',
      'alias',
      'clothAssessmentConfig',
      'shieldInfo',
      'cameraInfo',
    ]),
    ...mapGetters(['cameraId', 'isLoading']),
    ...mapGetters('review', [
      'labels',
      'diffClothAssessment',
      'labelInfo',
      'labelTable',

      'curLayerData',
      'curBaseLayer',
      'tools',
    ]),
    filteredLabels() {
      return this.labels.filter(
        label =>
          label.frameRange[0] <= this.frameIdx &&
          label.frameRange[1] >= this.frameIdx,
      )
    },
    curMachineAlias() {
      if (this.tarId === '') return ''
      const machineId = /([^:]+)/.exec(this.tarId)[1]
      const aliasItem = this.alias.find(item => item.id === machineId)
      return aliasItem ? aliasItem.alias : ''
    },
  },
  methods: {
    ...mapMutations(['setFrameIdx', 'setTotalFrameCount']),
    ...mapMutations('review', ['setLabelList']),
    ...mapActions(['fetchCameraList', 'fetchVideoYaml', 'fetchCameraInfo']),
    ...mapActions('review', [
      'fetchLabelers',
      'approveLabel',
      'rejectLabel',
      'handleToolEvent',
    ]),
    ...mapActions('search', ['fetchTarList']),
    onDecoded(canvasData, totalFrameCount) {
      const frameIdx = this.$route.query.frame || 0
      this.setFrameIdx(Number(frameIdx))
      this.setTotalFrameCount(Number(totalFrameCount))
    },
    setFrameRangeStart() {
      const curFrameIdx = this.frameIdx
      const curFrameRange = this.frameRange
      if (curFrameIdx <= curFrameRange[1]) {
        this.frameRange = [curFrameIdx, curFrameRange[1]]
      } else {
        this.frameRange = [curFrameIdx, curFrameIdx]
      }
    },
    setFrameRangeEnd() {
      const curFrameIdx = this.frameIdx
      const curFrameRange = this.frameRange
      if (curFrameIdx >= curFrameRange[0]) {
        this.frameRange = [curFrameRange[0], curFrameIdx]
      } else {
        this.frameRange = [curFrameIdx, curFrameIdx]
      }
    },
    approveBest() {
      this.bestLabeling = true
      this.approve()
    },
    refreshSearchList() {
      this.fetchTarList(this.$route.name)
    },
    approveNotBest() {
      this.bestLabeling = false
      this.approve()
    },
    approve() {
      this.approveLabel()
        .then(() => {
          this.$notify.success({
            title: '审核通过成功',
            message: '标注审核通过成功',
          })
          this.modified = false
          this.fetchLabelers({ selectedLabelerIdx: this.selectedLabelerIdx })
          this.refreshSearchList()
        })
        .catch(() => {
          this.$notify.error({
            title: '审核通过失败',
            message: '标注审核通过失败',
          })
        })
    },
    reject() {
      this.bestLabeling = false
      this.rejectLabel()
        .then(() => {
          this.$notify.success({
            title: '审核驳回成功',
            message: '标注审核驳回成功',
          })
          this.modified = false
          this.fetchLabelers({ selectedLabelerIdx: this.selectedLabelerIdx })
          this.refreshSearchList()
        })
        .catch(() => {
          this.$notify.error({
            title: '审核驳回失败',
            message: '标注审核驳回失败',
          })
        })
    },
    onMouseWheel(e) {
      this.isPlaying = false
      if (e.deltaY > 0) {
        this.frameIdx--
      } else {
        this.frameIdx++
      }
    },
    reset() {
      this.reviewComment = ''
    },
    setLabel(idx) {
      if (this.labelers[idx]) {
        const labelData = JSON.parse(this.labelers[idx].labelData)
        const labelList = labelData.map(label => {
          return {
            type: `${label.type}_${label.typeDetail}`,
            frameRange: [label.startIndex, label.endIndex],
            area: label.position,
          }
        })
        this.setLabelList(labelList)
      } else {
        this.setLabelList([])
      }
    },
  },
  watch: {
    cameraId(val) {
      if (val >= 0) {
        this.fetchLabelers()
      }
    },
    selectedLabelerIdx(idx) {
      this.setLabel(idx)
    },
    labelers() {
      this.setLabel(0)
    },
    labelTable(val) {
      this.reviewComment = val && val.length > 0 && val[0].reviewComment
    },
    cameraList() {
      this.fetchCameraInfo()
    },
  },
  components: {
    Version,
    Labeler,
    PlayControl,
    WebGLSnapshot,
    ClothAssessment,
  },
}
</script>

<style lang="scss">
.bitrate-select {
  width: 100px;
  .el-input__inner {
    height: 20px;
    line-height: 20px;
  }
  .el-input__icon {
    line-height: 20px;
  }
}
</style>

<style lang="scss" scoped>
.review {
  flex: 99;
  max-width: 1940px;
  overflow: auto;
  &-layer {
    margin: 5px;
  }
  &-labeler {
    box-shadow: 0px 2px 5px #ccc;
    margin: 10px;
    padding-bottom: 5px;
  }
  &-camera {
    width: 100%;
    max-width: 1920px;
    display: flex;
    align-items: center;
    padding: 0 10px 10px;
  }
  &-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-around;
  }
  &-list {
    padding: 5px;
    border: 1px solid #ccc;
    overflow: auto;
    height: 0;
    text-align: left;
    flex: 1;
    overflow: auto;
    border-radius: 4px;
    & > li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
      padding: 0 5px;
    }
    & .active {
      background: #00f1;
    }
  }

  &-tag {
    width: 100%;
    text-align: left;
    padding-left: 28px;
    & .el-tag {
      margin-right: 2px;
    }
  }
}
.box {
  padding: 10px;
  margin: 15px 10px 10px 10px;
  box-shadow: 0px 2px 5px #ccc;
  border-radius: 4px;
}
</style>
